@if (changeLog) {
  <div class="change-log">
    @for (change of changeLog; track change) {
      <div
        class="change-log__entry"
        [ngClass]="[change.markerNew ? 'icon-dot' : '', change.type, change.userAction ? 'user-action' : '']">
        {{ change.label }}
      </div>
    }
  </div>
}
